export default __webpack_public_path__ + "static/media/hand_decoration.c51a8ed8.svg";